module.exports = __webpack_public_path__ + "fonts/iconfont.d2870b44.eot";